/* ✅ Universal Money Formatter */
window.__dcsCustomQuickAddInitialized = true;
window.Shopify = window.Shopify || {};
Shopify.formatMoney =
  Shopify.formatMoney ||
  function (cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents);

    const currency = Shopify.currency?.active || 'AUD';
    const amount = (cents / 100).toFixed(2);

    return `$${amount} ${currency}`;
  };

/* ✅ OPEN MODAL */
document.addEventListener(
  'click',
  async function (e) {
    const trigger = e.target.closest('.custom-quick-add-btn');
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = trigger.dataset.productHandle;
    if (!handle) return;

    const modal = document.getElementById('custom-quick-add-modal');
    if (!modal) return;

    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    const product = await fetch(`/products/${handle}.js`).then((r) => r.json());

    document.getElementById('quick-add-title').textContent = product.title;

    document.getElementById('quick-add-image').src = (product.images[0] || '').replace(/(\.[^./]+$)/, `_500x$1`);

    document.getElementById('quick-add-price').textContent = Shopify.formatMoney(product.variants[0].price);

    document.getElementById('quick-add-variant-id').value = product.variants[0].id;

    buildOptions(product);
    updateVariant(product);
    updateStock(product.variants[0].available);
    addProductLink(product);
  },
  true,
);
/* ✅ CLOSE ON OVERLAY OR X */
document.addEventListener('click', (e) => {
  const close = e.target.closest("[data-action='close-custom-modal']");
  if (close) closeQuickAdd();
});

/* ✅ CLOSE ON ESC */
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeQuickAdd();
});

function closeQuickAdd() {
  const modal = document.getElementById('custom-quick-add-modal');
  modal.style.display = 'none';
  document.body.style.overflow = '';

  // ✅ Reset / clear the image
  const img = document.getElementById('quick-add-image');
  img.src = '';
}

/* ✅ BUILD SWATCH OPTIONS INSTEAD OF DROPDOWNS */
function buildOptions(product) {
  const container = document.getElementById('quick-add-options');
  container.innerHTML = '';

  product.options.forEach((opt, index) => {
    const wrap = document.createElement('div');
    wrap.className = 'swatch-group';

    const label = document.createElement('div');
    label.className = 'swatch-label';
    label.textContent = opt.name;
    wrap.appendChild(label);

    opt.values.forEach((v) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'swatch-btn';
      btn.dataset.optionIndex = index;
      btn.dataset.value = v;
      btn.textContent = v;

      btn.addEventListener('click', () => {
        // remove previous selection
        wrap.querySelectorAll('.swatch-btn').forEach((b) => b.classList.remove('active'));
        btn.classList.add('active');

        updateVariant(product);
      });

      wrap.appendChild(btn);
    });

    container.appendChild(wrap);

    // Auto select first value
    wrap.querySelector('.swatch-btn').classList.add('active');
  });
}

function addProductLink(product) {
  const el = document.getElementById('quick-add-link');
  el.href = `/products/${product.handle}`;
}

/* ✅ UPDATE WHEN VARIANT CHANGES */
function updateVariant(product) {
  const groups = [...document.querySelectorAll('.swatch-group')];

  const chosen = groups.map((g) => {
    const active = g.querySelector('.swatch-btn.active');
    return active?.dataset.value;
  });

  const variant = product.variants.find((v) => v.options.every((o, i) => o === chosen[i]));

  if (variant) {
    // ✅ update your existing hidden input
    document.getElementById('quick-add-variant-id').value = variant.id;

    // ✅ update the submit hidden input(s)
    document.querySelectorAll("input[name='id']").forEach((input) => {
      input.value = variant.id;
    });

    document.getElementById('quick-add-price').textContent = Shopify.formatMoney(variant.price);
    updateStock(variant.available);

    // ✅ Toggle submit button based on availability
    toggleSubmitButton(!variant.available, variant, product);

    // ✅ update image (if available)
    const img = document.getElementById('quick-add-image');
    if (!img) return;

    const imgWrap = img.closest('.custom-modal-image');
    if (!imgWrap) return;

    if (variant.featured_image?.src) {
      imgWrap.classList.add('is-loading');

      const newSrc = variant.featured_image.src.replace(/(\.[^./]+$)/, `_500x$1`);

      const tempImg = new Image();
      tempImg.src = newSrc;

      tempImg.onload = () => {
        img.src = newSrc;
        imgWrap.classList.remove('is-loading');
      };
    }
  }
}

/* ✅ STOCK MESSAGE */
function updateStock(available) {
  const el = document.getElementById('quick-add-stock');
  el.innerHTML = available
    ? "<span style='color:green'>In Stock</span>"
    : "<span style='color:red'>Out of Stock</span>";
}

/* ✅ TOGGLE SUBMIT BUTTON (Add to Cart / Notify Me) */
function toggleSubmitButton(disable = true, variant, product) {
  const submitBtn = document.querySelector('.quick-add-submit-btn');
  const btnText = submitBtn.querySelector('.submit-button-text');

  if (disable) {
    // Notify Me
    submitBtn.setAttribute('type', 'button');
    submitBtn.setAttribute('id', 'notifyBtn');
    submitBtn.classList.add('notify-me-button');

    // Store data attributes for notify functionality
    submitBtn.dataset.variantId = variant.id;
    submitBtn.dataset.productId = product.id;
    submitBtn.dataset.variantTitle = variant.title;
    submitBtn.dataset.productTitle = product.title;
    submitBtn.dataset.productImage = variant.featured_image?.src ?? product.images[0] ?? '';
    if (btnText) {
      btnText.textContent = 'Notify Me';
    } else {
      submitBtn.textContent = 'Notify Me';
    }
  } else {
    // Add to Cart
    submitBtn.setAttribute('type', 'submit');
    submitBtn.removeAttribute('id');
    submitBtn.classList.remove('notify-me-button');

    // Clear data attributes
    delete submitBtn.dataset.variantId;
    delete submitBtn.dataset.productId;
    delete submitBtn.dataset.variantTitle;
    delete submitBtn.dataset.productTitle;
    delete submitBtn.dataset.productImage;

    if (btnText) {
      btnText.textContent = 'Add to Cart';
    } else {
      submitBtn.textContent = 'Add to Cart';
    }
  }
}

/* ✅ QUANTITY BUTTONS */
document.addEventListener('click', (e) => {
  if (e.target.dataset.action === 'increase-qty') {
    const input = e.target.parentNode.querySelector('.custom-qty-input');
    input.value = +input.value + 1;
  }
  if (e.target.dataset.action === 'decrease-qty') {
    const input = e.target.parentNode.querySelector('.custom-qty-input');
    if (input.value > 1) input.value = +input.value - 1;
  }
});

// {% comment %} /* ✅ ADD TO CART */
// document.getElementById("quick-add-form").addEventListener("submit", async (e) => {
//   e.preventDefault();
//   const fd = new FormData(e.target);

//   await fetch("/cart/add.js", { method:"POST", body: fd });

//   closeQuickAdd();
//   document.dispatchEvent(new CustomEvent("cart:updated"));
// }); {% endcomment %}

// /* ✅ NOTIFY ME BUTTON HANDLER */
// {% comment %} document.addEventListener("click", (e) => {
//   if (e.target.closest("#notifyBtn")) {
//     const btn = e.target.closest("#notifyBtn");

//     // You can integrate with your notification system here
//     // For example, open a notification modal or form
//     console.log("Notify Me clicked for:", {
//       variantId: btn.dataset.variantId,
//       productId: btn.dataset.productId,
//       variantTitle: btn.dataset.variantTitle,
//       productTitle: btn.dataset.productTitle,
//       productImage: btn.dataset.productImage
//     });

//     // Example: trigger a custom event for your notification system
//     document.dispatchEvent(new CustomEvent("notify:request", {
//       detail: {
//         variantId: btn.dataset.variantId,
//         productId: btn.dataset.productId,
//         variantTitle: btn.dataset.variantTitle,
//         productTitle: btn.dataset.productTitle,
//         productImage: btn.dataset.productImage
//       }
//     }));

//     alert(`We'll notify you when "${btn.dataset.productTitle} - ${btn.dataset.variantTitle}" is back in stock!`);
//   }
// }); {% endcomment %}
